import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Represents the JSON used in the speech.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */
export var SpeechContext = /*#__PURE__*/function () {
  function SpeechContext(dynamicGrammar) {
    _classCallCheck(this, SpeechContext);

    this.privContext = {};
    this.privDynamicGrammar = dynamicGrammar;
  }
  /**
   * Adds a section to the speech.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializeable object that represents the value.
   */


  _createClass(SpeechContext, [{
    key: "setSection",
    value: function setSection(sectionName, value) {
      this.privContext[sectionName] = value;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var dgi = this.privDynamicGrammar.generateGrammarObject();
      this.setSection("dgi", dgi);
      var ret = JSON.stringify(this.privContext);
      return ret;
    }
  }]);

  return SpeechContext;
}();